
import moment from 'moment';

export default {
  data() {
    return {
      productInfo: {},
      planOptionsCopy: [],
      selectedPlanCode: '',
      defaultProductCode: 'axatp002',
      cPath: ''
    }
  },
  computed: {
    currentLang() {
      return this.$i18n.locale == 'zh-cn' ? 1 : 2
    },
    planOptions() {
      return this.$i18n.locale && this.planOptionsCopy.map((item, index) => {
        return {
          ...item,
          name: this.getNameFromIndex(index)
        }
      })
    }
  },
  created() {
    let { p, productCode } = this.$route.query;
    const defaultP = 'AS'; // 默认产品安盛
    p = p || defaultP;
    if (p == 'ZY') {
      this.skipModal = true;
    }
    if (productCode == 'BOCI19') {
      p = 'ZY19'
    }
    this.cPath = p == defaultP ? '' : p + '/';

    this._productType = p;
    this.fetchProductData(p);
    this.productCode = productCode;
  },
  methods: {
    fetchProductData(p) {
      // 定义产品相关信息
      import(`../data/${p}.js`).then(module => {
        Object.keys(module.default).forEach(key => {
          const value = module.default[key];
          if (value.toString().indexOf('$t') > -1) {
            const transfValue = value.replace(/\$t\(\"(.*)\"\)/gi, ($0, $1) => {
              return this.$t($1);
            });
            this.productInfo[key] = transfValue
          } else {
            this.productInfo[key] = module.default[key]
          }
        });
        this.productInfo = { ...this.productInfo }
      });
      // 定义保费计算相关信息
      import(`../dictData${p}.js`).then(module => {
        const { columns, columnsEn, planDays, premiumRules, premiumRulesEn, notileRules, notileColumns, notileRulesEn,
          premiumColumns, premiumColumnsEn,
          bzqy, bzqyEn, calcPremium, plans, plansEn
        } = module;
        this.columns = this.currentLang == 1 ? columns : columnsEn;
        this.premiumRules = this.currentLang == 1 ? premiumRules : premiumRulesEn;
        this.notileRules = this.currentLang == 1 ? notileRules : notileRulesEn;
        this.premiumColumns = this.currentLang == 1 ? premiumColumns : premiumColumnsEn;
        this.notileColumns = notileColumns;
        this.tableData = this.currentLang == 1 ? bzqy : bzqyEn;
        this.planDays = planDays;
        this._calcPremium = calcPremium
        this.calcPremium && this.calcPremium(1, 1);

        this.plans = plans;
        this.plansEn = plansEn;
        this.getPolicyPlan(this.productCode);
      })
    },
    clearRangeDateSelect(delay = 0) {
      const reset = () => {
        this.form.setFieldsValue({
          rangeDate: []
        });
        this.planOffsetDay = '';
      }
      if (delay) {
        let st = setTimeout(() => {
          clearTimeout(st);
          reset();
        }, delay);
        return
      }
      reset();
    },
    handlePlanSelect(val) {
      if (this.productCode == 'BOCI19') {
        this.plancode = val
        if ('BOCI195、BOCI196、BOCI197'.indexOf(val) > -1) {
          this.fullYearPlan = true
        }
        this.handleCountPremium()
      } else {
        val = this.planOptions.findIndex(item => item.code == val);
        const type = val + 1;
        const temp = type % 3;
        // 计划转化成数字映射来计算保费
        this._planIndex = temp == 0 ? 3 : temp
        this._planValue = type
        let days = type > 3 ? 'year' : this.offsetDays || 1
        this.fullYearPlan = days == 'year' ? 1 : 0
        this.sumPremium = 0
        if (days) {
          this.calcPremium(days)
        }
        // 添加保单页面用到
        const offsetDay = this._offsetDay
        if ((offsetDay && offsetDay < 365 && this.fullYearPlan) || (offsetDay && offsetDay > 364 && !this.fullYearPlan)) {
          this.clearRangeDateSelect()
        }
      }
    },
    getNameFromIndex(index) {
      return this.currentLang == 1 ? this.plans[index] : this.plansEn[index];
    },
    getPolicyPlan(productCode = '') {
      this.$api.getPolicyPlan({
        productCode: productCode || 'axatp002'
      }).then(res => res.data).then(data => {
        this.planOptionsCopy = data.content.map((item, index) => {
          return {
            ...item,
            name: this.getNameFromIndex(index)
          }
        })
        this.selectedPlanCode = data.content[0].code
      }).catch(() => {
      })
    },
    disabledDate(current) {
      // Can not select days before today and today
      if (this._startDate && this._minSelectDays) {
        const offsetDay = this._minSelectDays - 1
        const endDate = moment(this._startDate).add(offsetDay, 'days')
        const startDate = moment(this._startDate).add(-offsetDay, 'days')
        return (current && (current < moment().endOf("day") || (this._startDate < current && current < endDate) || (startDate < current && current < this._startDate)))
      }
      return (
        (current && current < moment().endOf("day"))
      );
    },
  }
}